// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// hooks
import useAuth from './hooks/useAuth';
// components
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ModalPopupTimer from './components/ModalPopupTimer';

// ----------------------------------------------------------------------

export default function App() {
  const { isInitialized } = useAuth();

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <GoogleOAuthProvider clientId="682035585205-347aklfh589s4mo63q72s218cgktqp3m.apps.googleusercontent.com">
                <GlobalStyles />
                <ProgressBarStyle />
                <BaseOptionChartStyle />
                {/* <Settings /> */}
                <ScrollToTop />
                <GoogleAnalytics />
                <ModalPopupTimer />
                {isInitialized ? <Router /> : <LoadingScreen />}
              </GoogleOAuthProvider>
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
